import "./GuestExperience.module.css";
import Header from "@/reusable_sections/Header";
import TailoredForYourTrip from "./sections/TailoredForYourTrip";
import CommonQuestions from "./sections/CommonQuestions";
import ReadyToRelax from "./sections/ReadyToRelax";
import Footer from "@/reusable_sections/Footer";
export default function GuestExperiencePage() {
  return <div>
      <Header />
      <TailoredForYourTrip />
      <CommonQuestions />
      <ReadyToRelax />
      <Footer />
    </div>;
}